import { onUnmounted, ref } from "vue"

const targets = new Map<string, HTMLElement>()

export const useScrollOpacityTarget = () => {
  const progress = ref(0)

  const setTarget = (id: string, el: HTMLElement | null) => {
    if (el) {
      targets.set(id, el)
    } else {
      targets.delete(id)
    }
    // Under <Suspense> the incoming view mounts before the outgoing one
    // unmounts, so only clear the target if it still points at this element —
    // otherwise the old component's cleanup wipes the entry the new one just set.
    onUnmounted(() => {
      if (targets.get(id) === el) targets.delete(id)
    })
  }

  const addTargetListener = (
    id: string,
    progressFn: (el: HTMLElement) => number,
  ) => {
    const onScroll = () => {
      const el = targets.get(id)
      if (el) progress.value = progressFn(el)
    }
    window.addEventListener("scroll", onScroll, { passive: true })
    onScroll()
    onUnmounted(() => window.removeEventListener("scroll", onScroll))
  }

  return { setTarget, addTargetListener, progress }
}
